import { useNavigate } from 'react-router'
import {Input} from 'antd'
import dayjs from 'dayjs'
import {
  Form, FormItem, DatePicker, InputAmount, Select,
  Box, Button,
} from 'common/components'
import {formatDate} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {useCreateRequest} from '../../requests/api.journal'
import { useUpdateJournal } from 'modules/request/api.journal'

const {TextArea} = Input
const JOURNAL_TYPE_OPTIONS = [
  { value: 'Journal Credit',                  label: 'Journal Credit'},
  { value: 'Journal Debit',                   label: 'Journal Debit'},
  { value: 'Journal Default Interest Credit', label: 'Journal Default Interest Credit'},
]

interface VariationFormProps {
  initialValues?: any
  projectUuid: string
  onClose: () => void
}

export default function VariationJournalForm({
  initialValues,
  projectUuid,
  onClose,
}: VariationFormProps) {
  const navigate = useNavigate()
  const {mutate: createRequest, isMutating: isCreating} = useCreateRequest((newReq:any) => {
    onClose?.()
    navigate(`/requests/journal${!!newReq?.uuid ? ('/' + newReq.uuid) : ''}`)
  })
  const {mutate: updateJournal, isMutating: isUpdating} = useUpdateJournal(initialValues?.uuid, () => {
    onClose?.()
  })
  const isMutating = isCreating || isUpdating

  const handleFinish = (values: any) => {
    const newValues = {
      projectUuid,
      amount: values.amount,
      type: values.type,
      date: formatDate(dayjs(values.date).format('YYYY-MM-DD'), 'server'),
      // "endDate": "2024-12-25",
      statementNote: values.statementNote,
      comment: values.comment,
    }
    if (!initialValues) {
      createRequest(newValues)
    } else {
      // console.log(initialValues?.uuid)
      // console.log(newValues)
      updateJournal(newValues)
    }
  }

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <FormItem
        name="type"
        label="Type"
        rules={FIELD_RULES}
      >
        <Select options={JOURNAL_TYPE_OPTIONS} />
      </FormItem>
      <FormItem
        name="date"
        label="Date"
        rules={FIELD_RULES}
      >
        <DatePicker
          minDate={dayjs().startOf('month').toDate()}
        />
      </FormItem>
      <FormItem
        name="amount"
        label="Amount, $ nzd"
        rules={FIELD_RULES}
      >
        <InputAmount />
      </FormItem>
      <FormItem
        name="statementNote"
        label="Statement note"
        rules={FIELD_RULES}
      >
        <Input />
      </FormItem>
      <FormItem
        name="comment"
        label="Comments for review"
        rules={FIELD_RULES}
      >
        <TextArea rows={5} />
      </FormItem>
      <Box align="center" mt={12}>
        <Button htmlType="submit" loading={isMutating}>
          Confirm
        </Button>
      </Box>
    </Form>
  )
}
